var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadianceRenewal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EBD5C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5489 12.6945C23.7301 12.3152 24.27 12.3152 24.4512 12.6945L27.5199 19.1187C27.5864 19.258 27.7136 19.3588 27.8645 19.3917L34.6465 20.8706C35.054 20.9595 35.18 21.4787 34.8587 21.7444L29.5672 26.1207C29.4192 26.2431 29.3544 26.4395 29.4005 26.6259L30.9105 32.737C31.0174 33.1697 30.5476 33.5155 30.1663 33.2848L24.2589 29.7107C24.0998 29.6144 23.9003 29.6144 23.7412 29.7107L17.8339 33.2848C17.4525 33.5155 16.9827 33.1697 17.0896 32.737L18.5996 26.6259C18.6457 26.4395 18.5809 26.2431 18.4329 26.1207L13.1414 21.7444C12.8201 21.4787 12.9461 20.9595 13.3536 20.8706L20.1356 19.3917C20.2865 19.3588 20.4137 19.258 20.4803 19.1187L23.5489 12.6945Z",
    fill: "#B0654D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9407 13.8096L13.0845 11.9534",
    stroke: "#B0654D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27637 21.2876H10.9014",
    stroke: "#B0654D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1514 21.2876H39.7764",
    stroke: "#B0654D",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9438 33.1602L12.8202 34.7031",
    stroke: "#B0654D",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0649 33.1611L35.1886 34.7041",
    stroke: "#B0654D",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0649 13.8096L34.9211 11.9534",
    stroke: "#B0654D",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 39.9531V37.3281",
    stroke: "#B0654D",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.2031V7.57813",
    stroke: "#B0654D",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadianceRenewal);
export default __webpack_public_path__ + "static/media/radiance-renewal.791c08b367d6c4d26444f8ede0a8afcd.svg";
export { ForwardRef as ReactComponent };